import React, { useEffect, useState } from "react";
import "./login.css";
import {
  TextField,
  Button,
  Typography,
  Grid,
  InputAdornment,
  IconButton,
  Alert,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CancelIcon from "@mui/icons-material/Cancel";
import instance from "../../ApiInstance/Inetrceptor";
const Forgotpassword = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [recoverycode, setRecoverycode] = useState("");
  const [error, setError] = useState("");
  const [errorcode, setErrorcode] = useState("");
  const [usernamePlaceholder, setUsernamePlaceholder] = useState("Username");
  const [recoveryPlaceholder, setRecoveryPlaceholder] =
    useState("Recovery code");
  const [showEmailIcon, setShowEmailIcon] = useState(false);
  const [recoverymodule, setRecoverymodule] = useState(false);

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };
  const handleRecoveryChange = (event) => {
    setRecoverycode(event.target.value);
  };
  const [timmer, setTimmer] = useState(null);
  const [timmerActivate, setTimmerActivate] = useState(false);
  const handleUsernameFocus = () => {
    setUsernamePlaceholder("Enter your email address");
    setShowEmailIcon(true);
  };
  const handlerecoveryFocus = () => {
    setRecoveryPlaceholder("Enter your recovery code");
  };
  const handleUsernameBlur = (event) => {
    if (event.target.value.trim() === "") {
      setUsernamePlaceholder("Username");
      setShowEmailIcon(false);
    }
  };

  const isEmailValid = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const isCodeValid = (recoverycode) => {
    return recoverycode.length >= 6;
  };
  const optVerificaiton = () => {
    if (!timmerActivate) {
      getOtpByMail();
    } else {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString();
      const body = {
        Id: 0,
        Email: username,
        Otp: recoverycode,
        ExpiryTime: formattedDate,
      };
      try {
        // setBackDrop(true);
        instance
          .post("api/v1/User/VerifyOTP", body)
          .then((res) => {
            console.log(res, "responce");
            if (res?.data?.Success) {
              navigate("/reset-password", {
                state: {
                  mailId: username,
                  otp: recoverycode,
                },
              });
              // setError(null);
              // setRecoverymodule(true);
            } else {
              setErrorcode(res?.data?.ResultMessage);
              setTimeout(() => {
                setErrorcode(null);
              }, 5000);
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            // setBackDrop(false);
          });
      } catch (err) {
        console.log(err);
      }
    }
  };
  const returnTime = () => {
    return timmer;
  };
  useEffect(() => {
    let timmerIntervalId;
    if (timmerActivate) {
      timmerIntervalId = setTimeout(() => {
        console.log(returnTime(), "returnTime()");
        if (returnTime() > 0) setTimmer((prev) => prev - 1);
        else {
          setTimmerActivate(false);
        }
      }, 1000);
    } else {
      clearTimeout(timmerIntervalId);
    }
    return () => clearTimeout(timmerIntervalId);
  }, [timmerActivate, timmer]);
  const getOtpByMail = () => {
    try {
      // setBackDrop(true);
      instance
        .get(`api/v1/User/GetOTP?email=${username}`)
        .then((res) => {
          if (res?.data?.Success) {
            setError(null);
            setRecoverymodule(true);
            setTimmer(120);
            setTimmerActivate(true);
          } else {
            setError(res?.data?.ResultMessage);
            setTimeout(() => {
              setError(null);
            }, 5000);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          // setBackDrop(false);
        });
    } catch (err) {
      console.log(err);
    }
  };
  const handleRecoverPassword = () => {
    const enteredEmail = username;
    if (!isEmailValid(enteredEmail)) {
      setError("Please enter a valid username.");
    } else {
      setError("");
      getOtpByMail();
      // Additional login logic here...
    }
  };
  // const handleResetPassword = () => {
  //   const enteredcode = recoverycode;
  //   if (!isCodeValid(enteredcode)) {
  //     setErrorcode("Please enter a valid code.");
  //   } else {
  //     setErrorcode("");
  //     optVerificaiton();
  //     // Additional login logic here...
  //   }
  // };
  const handleCloseError = () => {
    setError(""); // Clear the error message
  };
  const handleCloseErrorcode = () => {
    setErrorcode(""); // Clear the error message
  };
  return (
    <Grid container sx={{ height: "100%" }}>
      <Grid
        item
        lg={7}
        md={6}
        xs={12}
        sm={12}
        sx={{
          backgroundImage: "url(assets/Images/LoginBackground.svg)",
          backgroundSize: "cover",
          borderBottomRightRadius: "20px",
          borderTopRightRadius: "20px",
        }}
      ></Grid>
      <Grid item lg={5} md={6} xs={12} sm={12}>
        <div className="Logo-style">
          <img
            src="assets/Images/Logo.svg"
            alt="Logo"
            style={{
              width: "40%",
              height: "15%",
              // objectFit: 'cover',
            }}
          />
          {recoverymodule !== true ? (
            <>
              <Typography variant="h7" component="h1" className="font-color">
                Password Recovery
              </Typography>

              <Typography
                variant="h7"
                component="h7"
                className="font-color mt-4"
              >
                Enter the email address you used when you joined and <br />{" "}
                we'll send your code to reset your password
              </Typography>

              {error && (
                <Alert
                  variant="outlined"
                  severity="error"
                  icon={<CancelIcon onClick={handleCloseError} />}
                  className="errorAlert mt-4"
                >
                  {error}
                </Alert>
              )}

              <TextField
                required
                id="username"
                name="username"
                label="Email"
                className="mt-4"
                fullWidth
                autoComplete="family-name"
                variant="standard"
                onFocus={handleUsernameFocus}
                onBlur={(event) => handleUsernameBlur(event)}
                onChange={handleUsernameChange}
                InputProps={{
                  startAdornment: showEmailIcon && (
                    <InputAdornment position="start">
                      <IconButton>
                        <EmailIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                  placeholder: usernamePlaceholder,
                }}
                InputLabelProps={{
                  style: { color: "var(--color-primary)" },
                }}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={handleRecoverPassword}
                className="button-style"
                color="secondary"
              >
                Recover my password
              </Button>
              <br />
              <Grid container>
                <Grid item lg={12} textAlign="center">
                  <Typography
                    variant="h6"
                    component="h1"
                    className="font-color"
                  >
                    OR
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid
                  item
                  lg={12}
                  textAlign="center"
                  style={{ paddingTop: "8px" }}
                >
                  <Link
                    to="/login"
                    style={{
                      textDecoration: "none",
                      color: "var(--color-primary)",
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h1"
                      className="font-color"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <ArrowBackIcon style={{ paddingTop: "5px" }} />
                      Login to my account
                    </Typography>
                  </Link>
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <Typography variant="h7" component="h1" className="font-color">
                Password reset
              </Typography>
              <Typography
                variant="h7"
                component="h7"
                className="font-color font-sizehead mt-4"
              >
                We sent the code to <b>{`${username}`}</b>
              </Typography>
              {errorcode && (
                <Alert
                  variant="outlined"
                  severity="error"
                  icon={<CancelIcon onClick={handleCloseErrorcode} />}
                  className="errorAlert mt-4"
                >
                  {errorcode}
                </Alert>
              )}

              <TextField
                required
                id="code"
                name="code"
                label="Recovery code"
                className="mt-4"
                fullWidth
                value={recoverycode}
                autoComplete="family-name"
                variant="standard"
                onFocus={handlerecoveryFocus}
                onChange={handleRecoveryChange}
                InputProps={{
                  placeholder: recoveryPlaceholder,
                }}
                InputLabelProps={{
                  style: { color: "var(--color-primary)" },
                }}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={optVerificaiton}
                className="button-style"
                color="secondary"
              >
                {timmerActivate ? "Verify otp" : "Generate New otp"}
              </Button>
              <Typography
                variant="h7"
                component="h7"
                className="font-color font-sizehead mt-4"
              >
                {timmerActivate && `Code is valid for ${timmer} seconds`}
              </Typography>
            </>
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export default Forgotpassword;
